import type { IGridCustomer } from 'src/types/customers';

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import { Box } from '@mui/material';
import UserAvatar from 'src/components/user-avatar/UserAvatar';
import CountryWithFlag from 'src/components/country-with-flag/CountryWithFlag';
import { fCurrency } from 'src/utils/format-number';

type OwnProps = {
  row: IGridCustomer;
  selected: boolean;
  rowIndex: number;
};

export function CustomersGridRow({ row, selected, rowIndex }: OwnProps) {
  return (
    <TableRow hover selected={selected} data-test-id={`row-${rowIndex}`}>
      <TableCell>
        <Box sx={{ gap: 2, display: 'flex', alignItems: 'center' }}>
          <UserAvatar
            dataTestId="name-link"
            name={row.name}
            subText={row.inioCustomerNo}
            to={row.id}
          />
        </Box>
      </TableCell>

      <TableCell>
        <CountryWithFlag countryCode={row.countryCode} />
      </TableCell>

      <TableCell align="right" sx={{ fontWeight: 600 }} data-test-id="total-remaining-balance-link">
        {fCurrency(row.totalRemainingBalance, {
          minimumFractionDigits: 2,
          currency: row.currency,
        })}
      </TableCell>

      <TableCell align="center" data-test-id="open-invoices-link">
        {row.openInvoices}
      </TableCell>
    </TableRow>
  );
}
